import { FC } from 'react';
import './TableGeneralModal.css';
import React from 'react';
import i18n from '../../../main/initializers/i18n';

type TMVariant = 'default' | 'danger' | 'success' | 'warning';

interface Props {
  handleClose?: () => void;
  handleClick?: () => void;
  children: React.ReactNode;

  width?: string;
  minwidth?: string;
  radius?: string;
  height?: string;

  headerName: string;
  variant?: TMVariant;

  isFullScreen?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
}

const TableGeneralModal: FC<Props> = ({
  handleClick,
  handleClose,
  children,
  width,
  minwidth,
  radius,
  height,
  headerName,
  variant = 'default',
  isFullScreen,
  hideHeader,
  hideFooter,
}) => {
  return (
    <div className="tmOverlay" role="dialog" aria-modal="true">
      <div
        className={`tmContainer ${isFullScreen ? 'isFullScreen' : ''}`}
        style={{
          ...(width ? ({ ['--tm-w' as any]: width } as React.CSSProperties) : {}),
          ...(minwidth ? ({ ['--tm-minw' as any]: minwidth } as React.CSSProperties) : {}),
          ...(height ? ({ ['--tm-h' as any]: height } as React.CSSProperties) : {}),
          ...(radius ? ({ ['--tm-r' as any]: radius } as React.CSSProperties) : {}),
        }}
      >
        {!hideHeader && (
          <div className={`tmHeader is-${variant}`}>
            <h5 className="tmTitle">{headerName}</h5>
            <button className="tmClose" onClick={handleClose} aria-label="Close">
              ×
            </button>
          </div>
        )}

        <div className="tmBody">{children}</div>

        {!hideFooter && (
          <div className={`tmFooter ${isFullScreen ? 'isFull' : ''}`}>
            <button className="tmBtn tmBtnGhost" onClick={handleClose}>
              {i18n.t('actions.cancel')}
            </button>
            <button className="tmBtn tmBtnPrimary" onClick={handleClick}>
              {i18n.t('actions.confirm')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableGeneralModal;
